import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUnderlineLine = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "currentColor",
	id: "svg1",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("defs", { id: "defs1" }), /* @__PURE__ */ _jsx("path", {
		id: "path2",
		d: "m 8,5.015625 c -0.4142096,0 -0.75,0.3357904 -0.75,0.75 v 6 c 0,2.624697 2.1267026,4.75 4.75,4.75 2.622497,0 4.75,-2.125403 4.75,-4.75 v -6 c 0,-0.4142096 -0.3358,-0.75 -0.75,-0.75 -0.4142,0 -0.75,0.3357904 -0.75,0.75 v 6 c 0,1.795798 -1.455502,3.25 -3.25,3.25 -1.795498,0 -3.25,-1.454302 -3.25,-3.25 v -6 c 0,-0.4142096 -0.3357904,-0.75 -0.75,-0.75 z m -2,14 c -0.4142096,0 -0.75,0.3358 -0.75,0.75 0,0.4142 0.3357904,0.75 0.75,0.75 h 12 c 0.4142,0 0.75,-0.3358 0.75,-0.75 0,-0.4142 -0.3358,-0.75 -0.75,-0.75 z"
	})]
});
export default SvgUnderlineLine;
